export const SERVER_URL = "https://api.thebusybee.app";

export const IMAGE_URL = "https://bucket.thebusybee.app/busybee/";
